module.exports = __webpack_public_path__ + "static/media/5-Halterung-Servatius-klein.fa2cdda7.jpg";